import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';


import ResponseTimeGeneralLight from '../../../Online/components/ResponseTime/ResponseTimeGeneralLight';
import ResponseTimeRankTable from '../../../Online/components/ResponseTime/ResponseTimeRankTable';
import AvailabilityGaugeChartLight from '../../../Online/components/AvailabilityGauge/AvailabilityGaugeChartLight';
import ErrorsEventsObjective from '../../../Online/components/ErrorsEventsObjective';


// Material helpers
import { withStyles } from '@material-ui/core/styles';
import { Link, withRouter } from 'react-router-dom';


// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';
// Custom components
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import RefreshIcon from '@material-ui/icons/Refresh';
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';
import Divider from '@material-ui/core/Divider';

// Material components
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/Info';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import ClearIcon from '@material-ui/icons/Clear';

import PerfectScrollbar from 'react-perfect-scrollbar';

// Palette
import palette from 'theme/palette';
// Component styles
import styles from './styles';

import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')


class ListObjectiveModal extends Component {

    constructor(props) {
        super(props);
        //console.log('list', props)
        this.handleResponseClick = this.handleResponseClick.bind(this);
        this.handleStepClick = this.handleStepClick.bind(this);
        this.handleNodeClick = this.handleNodeClick.bind(this);
        this.handlePeriodClick = this.handlePeriodClick.bind(this);
        this.handleNextStepClick = this.handleNextStepClick.bind(this);
        this.handleInfo = this.handleInfo.bind(this);
        this.handleFirstInfo = this.handleFirstInfo.bind(this);
        this.handleDateMoment = this.handleDateMoment.bind(this);
        this.state = {
            typeGraph: 0,
            period: 'd',
            step: 0,
            isForStep: false,
            nameStep: null,
            namePeriod: null,
            x: null,
            y: null,
            isLastEvent: false,
            objetive: this.props.match.params.objetivo_id,
            statePeriod: {},
            isStatePeriod: false,
            responseTimeGraphEl: null,
            periodEl: null,
            extendEl: null,
            nameGraph: [' Consolidado', ' Detalle por Paso', ' Detalle por Monitor'],
            namePeriodPorlet: ['Última Hora', 'Último Día'],
            typePeriod: 1,
            //nameSelectStep: "Seleccione Paso"
            nameSelectStep: "Información Extendida ",
            settingsEl: null,
            isRefresh: false,
            isInfo: null,
            checkedA: false,
            date: new Date(),
            dateMoment: ((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a")),
            detalleGraph:[' Corresponde a los tiempos de respuestas consolidados (promedio desde todos los ISPs) del objetivo durante el período y horario seleccionado.', 
                        ' Corresponde a la información estadística de los tiempos de respuestas del objetivo, separado por paso, durante el período y horario seleccionado.',
                        ' Corresponde a los tiempos de respuesta del objetivo,para cada ISP desde donde se monitorea el objetivo, separado por paso, durante el período y horario seleccionado.'],
            listObjectives: this.props.listObjective,
            objId: this.props.obj,
            mediciones: 0
        };
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
     }
     
     tick() {
         /*if(this.state.checkedA===true){
             this.setState({
             date: new Date(),
             dateMoment:((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a"))
             });
         }*/
     }

    handleResponseClick() {
        /*this.setState({
            typeGraph: 0,
            isForStep: false,
            isLastEvent: false,
            responseTimeGraphEl: null,
            nameSelectStep: "Seleccione Paso",
            isRefresh: false
        });*/
    }

    handleStepClick() {
        /*this.setState({
            typeGraph: 1,
            isForStep: true,
            isLastEvent: false,
            responseTimeGraphEl: null,
            isRefresh: false
        });*/
    }

    handleNodeClick() {
       /* this.setState({
            typeGraph: 2,
            isForStep: true,
            isLastEvent: false,
            responseTimeGraphEl: null,
            isRefresh: false
        });*/

    }

    handlePeriodClick(nextPeriod) {
       /* if (nextPeriod === 'hora') {
            this.setState({
                //typeGraph: prevTypeGraph,
                period: 'h',
                typePeriod: 0,
                namePeriod: 'Rango: últimas 3 horas',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } else if (nextPeriod === 'dia') {
            this.setState({
                //typeGraph: prevTypeGraph,
                period: "d",
                typePeriod: 1,
                namePeriod: 'Rango: último día',
                statePeriod: {},
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false
            });
        } */
    }
    
    handleNextStepClick = event => {
        /*const newSelectStep = event.currentTarget.name
        const newStep = event.currentTarget.id
        if (this.state.step !== newStep) {
            this.setState({
                //typeGraph: prevTypeGraph,
                //period: prevPeriod,
                step: newStep,
                isLastEvent: false,
                extendEl: null,
                nameSelectStep: newSelectStep,
                isRefresh: false
            })
        }*/
    }
    handleInfo(props, step) {
       /* let oldDate = new Date(props.x)
        let year = oldDate.getUTCFullYear()
        let month = oldDate.getUTCMonth()
        let day = oldDate.getUTCDate()
        let hours = oldDate.getUTCHours()
        let minutes = oldDate.getUTCMinutes()
        let seconds = oldDate.getUTCSeconds()

        let newDate = new Date(year, (month), day, hours, minutes, seconds)
        this.setState({
            nameStep: step,
            x: newDate.toLocaleString(),
            y: props.y
        })*/
    }


    handleFirstInfo(props) {        
        if (this.state.mediciones !== props) {
            this.setState({
                mediciones: props,               
            })
        }
    }
    handleDateMoment(props) {
        this.setState({
            dateMoment: props,
            //isRefresh: false
        })
    }

    handleShowResponseTimeGraph = event => {
       /* this.setState({
            responseTimeGraphEl: event.currentTarget
        });*/
    };

    handleCloseResponseTimeGraph = () => {
        /*this.setState({
            responseTimeGraphEl: null
        });*/
    };

    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget,
           
        });
    };

    handleClosePeriod = event => {
        this.setState({
            periodEl: null,
            period: event.currentTarget.value,
            typePeriod: event.currentTarget.id
        });
    };
    handleClosePeriodSecondary = event => {
        this.setState({
            periodEl: null,
        });
    };

    handleShowExtend = event => {
       /* this.setState({
            extendEl: event.currentTarget
        });*/
    };

    handleCloseExtend = () => {
        /*this.setState({
            extendEl: null
        });*/
    };

    handleRefresh = event => {
       /* this.setState({
            isRefresh: true,
            settingsEl: null,
        })*/
    }

    handleShowSettings = event => {
       /* this.setState({
            settingsEl: event.currentTarget
        });*/
    };
    handleShowIsInfo = event => {
        /*this.setState({
            isInfo: event.currentTarget
        });*/
    };
    handleCloseSettings = () => {
       /* this.setState({
            settingsEl: null
        });*/
    };
    handleCloseIsInfo = () => {
        /*this.setState({
            isInfo: null
        });*/
    };
    handleChange = name=>event => {
        /*this.setState({ 
            checkedA: event.target.checked 
        });
        this.timerID = setInterval(
            () => this.tick(),
            300000
          );*/
      };

    componentDidUpdate(prevProps, prevState) {
        
    }

    render() {

        const { classes, className, handleClose, location, listObjectives, obj, ...rest } = this.props;
        const { typeGraph, responseTimeGraphEl, 
            periodEl, nameGraph, namePeriodPorlet, typePeriod, extendEl, nameSelectStep, settingsEl, isRefresh,isInfo, detalleGraph, 
        } = this.state;
  
        const showPeriodEl = Boolean(periodEl);
        const showIsInfo = Boolean(isInfo);
        const showExtendEl = Boolean(extendEl);
        const showSettingsEl = Boolean(settingsEl);

        const rootClassName = classNames(classes.root, className);
        const objective = [] 
        Object.keys(listObjectives).map(key => {            
            Object.keys(listObjectives[key]).map(key2 => {
                if (listObjectives[key][key2].objetivo_id == obj){
                    objective.push(listObjectives[key][key2]);
                }
            })
        })
        if (!this.state.dataError) {
            return (
                
                <Portlet
                    /*  {...rest} */
                    style={{backgroundColor:"#313131",borderRadius:'0%'}}
                    //className={rootClassName}
                >
                    
                    <PortletHeader className={classes.header}
                    >
                        <PortletLabel
                            /*  icon={<DevicesIcon />} */

                            variant="h5"
                            title={this.props.objName}
                        />

                        <PortletToolbar>
                            {/*<IconButton
                                //className={classes.refreshButton}
                                //variant="text"
                                onClick={this.handleShowSettings}
                            >
                                <SettingsOutlinedIcon />
                                
                            </IconButton>
                            <Popover
                                anchorEl={settingsEl}
                                
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                onClose={this.handleCloseSettings}
                                open={showSettingsEl}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}>
                                <IconButton
                                    className={classes.refreshButton}
                                    variant="text"
                                    onClick={this.handleRefresh}
                                    onClose={this.handleCloseSettings}
                                >
                                    <div>
                                    <RefreshIcon color="primary" /><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>Actualizar</Typography>
                                    </div>
                                </IconButton>
                                <IconButton
                                        onClick={this.handleShowIsInfo}
                                        onClose={this.handleCloseIsInfo}
                                    >
                                        <div>
                                            <InfoIcon color="secondary"/><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>Información</Typography>
                                        </div>
                                    </IconButton>
                                     <Popover
                                        anchorEl={isInfo}
                                        open={showIsInfo}
                                        onClose={this.handleCloseIsInfo}
                                        >
                                        <PortletContent variant="h4" style={{fontSize:'16px', color:'#66788A'}}>{detalleGraph[typeGraph]}</PortletContent>
                                    </Popover>
                                    <Tooltip title="Actualización Automatica cada 5 minutos">
                                        <div style={{textAlign:"center"}}>
                                            <Switch
                                                checked={this.state.checkedA}
                                                onChange={this.handleChange('checkedA')}
                                                value="checkedA"
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                            />
                                        </div>
                                    </Tooltip>

                            </Popover>*/}
                            <Button variant="h4" style={{fontSize:'15px',float:'left', color:'#fff'}} onClick={this.handleShowPeriod}>
                                {namePeriodPorlet[typePeriod]}<ArrowDropDownIcon />
                            </Button>
                            <IconButton style={{color:'#FFFFFF'}} onClick={handleClose}><ClearIcon/></IconButton>
                            <Popover
                                anchorEl={periodEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center'
                                }}
                                onClose={this.handleClosePeriodSecondary}
                                open={showPeriodEl}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center'
                                }}>
                                <List>
                                    <ListItem>
                                    <Button color='primary' style={{color:'#353535'}} value={'h'} id={0} onClick={this.handleClosePeriod} className="button muted-button">Última Hora</Button>
                                    </ListItem>
                                    <ListItem>
                                    <Button color='primary' style={{color:'#353535'}} value={'d'} id={1} onClick={this.handleClosePeriod} className="button muted-button">Último Día</Button>
                                    </ListItem>
                                </List>
                            </Popover>
                        </PortletToolbar>
                    </PortletHeader>
                    
                    <PortletContent className={classes.content}>
                        
                        <Grid
                            container
                            spacing={10}
                        >
                            <Grid
                                item
                                xs={12}
                                sm={7}
                                md={7}
                                xl={7}
                                //style={{border: "1px solid rgb(204, 204, 204)"}}
                                >        
                                    {<Graph props={this.props} state={this.state} onDateMoment={this.handleDateMoment}/>}
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={5}
                                md={5}
                                xl={5}
                                //style={{border: "1px solid rgb(204, 204, 204)"}}
                                >   
                              {/*   <div style={{float:"right"}}>
                                    <div style={{float:"left"}}>
                                        <QueryBuilderIcon/>
                                    </div>
                                    <Typography  style={{width:"350px", height:"1px", float:"right", marginTop:"5px", paddingLeft:"3px"}} color="textSecondary">
                                        Última Actualización {dateMoment}
                                    </Typography>
                                </div> */}
                                    <GraphGauge props={this.props} state={this.state} />
                                    {<Link to={{
                                        pathname: `/online/${objective[0].objetivo_id}/${objective[0].nombre}/${objective[0].nombre_servicio_unificado}`,
                                        state: {
                                            fromObjective: objective[0]
                                        }
                                    }}> 

                                    <br />
                                    <br />
                                    <br />

                                    <div>
                                        <Button style={{color: "#fff"}}  id={objective[0].nombre_servicio_unificado}>
                                            Ir a Detalle de Mediciones <ArrowRightIcon />
                                        </Button>
                                    </div>
                                </Link>}
                              
                            </Grid>
                            
                            
                        </Grid> 
                        
                        <Grid
                            container
                            spacing={10}
                        >
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={6}
                                xl={6}
                                //style={{border: "1px solid rgb(204, 204, 204)"}}
                                >




                                    <Portlet style={{border: "0px", backgroundColor:"#373537"}}>                                        
                                        <PortletContent>
                                            <div style={{float:"left",  marginLeft:"1%", marginBottom:"-1%"}}>

                                                <PortletLabel
                                                /*  icon={<DevicesIcon />} */
                                                style={{color:"white"}}
                                                variant="h6"
                                                title="TRANSACCIONES MÁS LENTAS (TOP 5)"
                                                />
                                            
                                            </div> 
                                            </PortletContent>   
                                           
                                            <div >
                                                {<TableRank props={this.props} state={this.state}/>}
                            
                                            </div>
                                    </Portlet>

                                    {/*                                
                                    <div style={{float:"right", marginTop:"5%"}}>
                                        <div style={{float:"left"}}>
                                            <QueryBuilderIcon/>
                                        </div>
                                        <Typography  style={{width:"350px", height:"1px", float:"right", marginTop:"5px", paddingLeft:"3px"}} color="textSecondary" gutterBottom>
                                            Última Actualización {dateMoment}
                                        </Typography>
                                    </div>
                                    */}
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={6}
                                xl={6}
                                //style={{border: "1px solid rgb(204, 204, 204)"}}
                                >   
                                        <div style={{float:"center", backgroundColor:"#373537"}}>
                                            {<TableError props={this.props} state={this.state} onFirstInfo={this.handleFirstInfo}/>}                                
                                        </div>                             
                            </Grid>                            
                        </Grid>     
                        
                    </PortletContent>
                    <PortletFooter className={classes.portletFooter}>                     
                        
                    </PortletFooter>                    
                </Portlet>
               

            )
        }
        else if (this.state.dataError) {
            return (<p>No hay datos..</p>)
        }
        else if (this.state.isLoading) {
            return (<p style={{color:"white"}}>Cargando..</p>)
        }
        else if (this.state.externalData == null) {
            return (<p style={{color:"white"}}>Cargando..</p>)
        }
        else return (<p>Error!</p>)
    }
}

function Graph(props, state) {    
    
    return <ResponseTimeGeneralLight params={props} state ={state}/>;
  
}
function GraphGauge(props, state) {  
    
    return <AvailabilityGaugeChartLight params={props} state ={state}/>;
  
}

function TableRank(props, state) {  
    
    return <ResponseTimeRankTable params={props} state ={state}/>;
  
}

function TableError(props, state) {  
    
    return <ErrorsEventsObjective params={props} state ={state}/>;
  
}


export default
    compose(withRouter, withStyles(styles))(ListObjectiveModal);